import angular from 'angular';

import component from './dealerChatButton.component';
import DataBroker from 'cars-ng-data-broker';
import NgTracking from 'cars-ng-tracking';
import NgBrowser from 'cars-ng-browser';
import ActiveEngage from '../../activeEngage';
import DealerChatService from '../index';
import LeadForm from '../../leadForm';

export default angular.module('vdp.dealerChat.dealerChatButton', [
    ActiveEngage,
    DataBroker,
    NgTracking,
    NgBrowser,
    DealerChatService,
    LeadForm
])

.component('carsDealerChatButton', component)

.name;
